import { render, staticRenderFns } from "./DocumentTypeTaxonomyItem.vue?vue&type=template&id=1193ab9a&scoped=true&"
import script from "./DocumentTypeTaxonomyItem.vue?vue&type=script&lang=ts&"
export * from "./DocumentTypeTaxonomyItem.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTypeTaxonomyItem.vue?vue&type=style&index=0&id=1193ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193ab9a",
  null
  
)

export default component.exports